'use strict';

export default {
  paymentModes: {
    singlePayment: 'Pay in Full',
    fixedDates: 'Payment Plan',
    fixedRecurrence: 'Payment Plan',
    subscription: 'Subscription',
    applyDiscount: 'Apply discount if this mode is selected',
    addPaymentMode: 'Add Payment Mode',
    fixedDatesMode: {
      installmentsCount: '{count} payment plan on the following dates',
    },
    errors: {
      invalidDate: 'This date is invalid',
      dateRequired: 'This date is required',
      discountMin: 'The discount must be higher or equal than 0',
      discountMax: 'The discount must be lower or equal than 100',
      installmentMin: 'The payment must be higher than 0',
      installmentMax: 'The payment must be lower or equal than 100',
      installmentsSum: 'The sum of payment plan must be 100',
      discountValueRequired: 'The discount value is required',
    },
  },
};
